import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { EMPTY_TEACHER_EXTENSIONS } from '../../services/TeacherAccessService';

export default function TeacherExtensionsFields({ value, onChange, disabled, idPrefix }) {
  const { t } = useTranslation();
  const settings = { ...EMPTY_TEACHER_EXTENSIONS, ...value };
  const change = (field, next) => onChange({ ...settings, [field]: next });
  return (
    <fieldset disabled={disabled} className="mt-3">
      <legend className="sr-only">{t('manage:teacherExtensions.title')}</legend>
      {['studentsReadAll', 'clientsReadAll'].map(field => (
        <label key={field} className="d-block" htmlFor={`${idPrefix}-extension-${field}`}>
          <input id={`${idPrefix}-extension-${field}`} type="checkbox" checked={settings[field]} onChange={event => change(field, event.target.checked)} />{' '}
          {t(`manage:teacherExtensions.${field}`)}
        </label>
      ))}
      {['classesManageScope'].map(field => (
        <label key={field} className="d-block" htmlFor={`${idPrefix}-extension-${field}`}>
          {t(`manage:teacherExtensions.${field}`)}
          <select id={`${idPrefix}-extension-${field}`} className="form-control" value={settings[field]} onChange={event => change(field, event.target.value)}>
            {['none', 'own', 'school'].map(scope => <option key={scope} value={scope}>{t(`manage:teacherExtensions.${scope}`)}</option>)}
          </select>
        </label>
      ))}
      <small className="d-block text-muted">{t('manage:teacherExtensions.explanation')}</small>
    </fieldset>
  );
}
TeacherExtensionsFields.propTypes = { value: PropTypes.object, onChange: PropTypes.func.isRequired, disabled: PropTypes.bool, idPrefix: PropTypes.string };
TeacherExtensionsFields.defaultProps = { value: EMPTY_TEACHER_EXTENSIONS, disabled: false, idPrefix: 'teacher' };
